export type PaisIA = 'ecuador' | 'colombia' | 'peru' | 'mexico' | 'chile' | 'argentina' | 'otro'

export const PAISES_IA: { value: PaisIA; label: string }[] = [
  { value: 'ecuador', label: 'Ecuador' },
  { value: 'colombia', label: 'Colombia' },
  { value: 'peru', label: 'Perú' },
  { value: 'mexico', label: 'México' },
  { value: 'chile', label: 'Chile' },
  { value: 'argentina', label: 'Argentina' },
  { value: 'otro', label: 'Otro' },
]

export interface ConsumoIA {
  id: number
  laboratorio_id: number
  laboratorio_nombre: string
  mes: number
  anio: number
  cantidad_imagenes: number
  costo_por_imagen: number
  costo_por_imagen_proveedor: number
  estado_cobro: 'pendiente' | 'cobrado'
  estado_pago_proveedor: 'pendiente' | 'pagado'
  pais: PaisIA
  costo_cliente: number
  costo_proveedor_registro: number
  fecha_actualizacion: string
}

export interface ResumenProveedor {
  total_imagenes: number
  costo_proveedor: number
  total_costo_cliente: number
  registros_count: number
}

export interface ConsumoIACreateInput {
  laboratorio_id: number
  mes: number
  anio: number
  cantidad_imagenes: number
  costo_por_imagen: number
  costo_por_imagen_proveedor: number
  estado_cobro: 'pendiente' | 'cobrado'
  estado_pago_proveedor: 'pendiente' | 'pagado'
  pais: PaisIA
}

export interface ConsumoIAUpdateInput {
  cantidad_imagenes?: number
  costo_por_imagen?: number
  costo_por_imagen_proveedor?: number
  estado_cobro?: 'pendiente' | 'cobrado'
  estado_pago_proveedor?: 'pendiente' | 'pagado'
  pais?: PaisIA
}

export interface ConsumoIAFilters {
  anio?: number
  mes?: number
  pais?: PaisIA
}
